import { Injectable } from '@angular/core';
import { PortalUser } from '../model/portaluser.model';

import API, { graphqlOperation } from '@aws-amplify/api';
import {
         BusinessQuery,
         BusinessesQuery,
         UpdateBusinessContactDetailsMutation,
         CreateBusinessMutation,
         DeleteBusinessMutation,
         PhoneNumberDetailInput,
         AddBusinessUserMutation,
         DeleteBusinessUserMutation,
         DeleteUserMutation,
         AccountByFirstLastQuery,
         AddNewUserMutation } from '../API.service';

import { business,
         businesses,
         accountByFirstLast
       } from '../../graphql/queries';

import { updateBusinessContactDetails,
         createBusiness,
         deleteBusiness,
         addBusinessUser,
         deleteBusinessUser,
         deleteUser,
         addNewUser } from '../../graphql/mutations';
import { businessesCustom } from '../../graphql/custom';

import * as moment from 'moment';

export interface AuctionBidderInfo {
  auctionId: string;
  lotId: string;
  bidderId: string;
}

@Injectable()
export class SellerService {
  sellersList:Seller[] = [];
  activeSeller:Seller;

  async loadSellers(forcereload=false, nextToken="",sortDirection="ASC") {
    if(this.sellersList.length == 0 || forcereload == true) {
      this.sellersList = [];
      let queryVars = {};
      queryVars['limit'] = 100;
      nextToken.length > 0 ? queryVars['nextToken'] = nextToken : "";
      queryVars['sortDirection'] = sortDirection;

      try{
        const response = (await API.graphql(graphqlOperation(businessesCustom,queryVars))) as {
          data: BusinessesQuery;
        };
        // console.log("graphql businesses",response);
        for(let item of response.data.businesses.items){
          let seller = new Seller();
          seller.loadResults(item);
          this.sellersList.push(seller);
        }
      }
      catch(err){
        console.log('error loading sellers list',err);
        throw(err)
      }
    }
    return this.sellersList;
  }

}

@Injectable()
export class Seller {

    public accountId:string;
    public businessName:string;
    public email:string;
    public familyName:string;
    public givenName:string;
    public nameTitle:string;
    public phone:string;
    public physicalAddress: string[];
    public physicalCity:string;
    public physicalState:string;
    public physicalZip:string;
    public physicalCountry:string;
    public physicalCountryStateCity:string;
    public billingAddress: string[];
    public billingCity:string;
    public billingState:string;
    public billingZip:string;
    public billingCountry:string;
    public termsOfService:boolean;
    public receiveInfo:boolean;
    public businessWebSite:string;
    public businessNotes:string;
    public businessTimezone:string;
    public businessPhoneNumbers:PhoneNumberDetailInput[];
    public version:number;
    public proxyUsers:PortalUser[];
    public associatedBusinesses:PortalUser[];

    public modifiedProxyUserIds:string[];
    public proxyUserIds:string[];

    public associatedBusinessIds:string[];
    public modifiedAssociatedBusinessIds:string[];

    constructor() {
      this.accountId = "";
    }

    async loadBusiness(accountId:string) {
        let queryVars = {};
        queryVars['accountId'] = accountId;

        try{
          const response = (await API.graphql(graphqlOperation(business,queryVars))) as {
            data: BusinessQuery;
          };
          console.log('loadBusiness',response);
          if(response.data.business == undefined){
            throw new Error('Error retrieving business. Contact your administrator.');
          }
          this.loadResults(response.data.business);
        }
        catch(err){
          console.log('error loading business',err);
          throw(err)
        }

      return this;
    }

    async updateBusiness(){
      if(this.accountId == undefined || this.accountId.length == 0){
        return this.createBusiness();
      }

      let updateVars = this.getUpdateVars();
      try{
        await this.saveProxyUsers();
        const response = (await API.graphql(graphqlOperation(updateBusinessContactDetails,{accountId:this.accountId,expectedVersion:this.version,input:updateVars}))) as {
          data: UpdateBusinessContactDetailsMutation;
        };

        if(response.data == undefined || response.data.updateBusinessContactDetails == undefined){
          throw new Error('Error updating business. Contact your administrator.');
        }
        this.loadResults(response.data.updateBusinessContactDetails);
      }
      catch(err){
        var errorMsg = err.errors[0].message;
        console.log('error updating business',err);
        throw(errorMsg)
      }
      return this;
    }

    async createBusiness(){
      try{
        const response = (await API.graphql(graphqlOperation(createBusiness,{input:this.getUpdateVars()}))) as {
          data: CreateBusinessMutation;
        };

        if(response.data == undefined || response.data.createBusiness == undefined){
          throw new Error('Error creating business. Contact your administrator.');
        }
        // console.log('create auction',response);
        this.accountId = response.data.createBusiness['accountId'];
        await this.saveProxyUsers();
        await this.loadBusiness(this.accountId);
        return this;
      }
      catch(err){
        var errorMsg = err.errors != undefined ? err.errors[0].message : err;
        console.log('error creating business',err);
        throw(errorMsg)
      }
    }

    async deleteBusiness(){
      try{
        await this.deleteProxyUsers();
        const response = (await API.graphql(graphqlOperation(deleteBusiness,{accountId:this.accountId}))) as {
          data: DeleteBusinessMutation;
        };

        if(response.data == undefined || response.data.deleteBusiness == undefined){
          throw new Error('Error deleting business. Contact your administrator.');
        }
        return;
      }
      catch(err){
        var errorMsg = err.errors != undefined ? err.errors[0].message : err;
        console.log('error deleting business',err);
        throw(errorMsg)
      }
    }

    getUpdateVars(){
      var updateVars = {};
      this.email != undefined ? (updateVars['email'] = this.email) : "";
      this.familyName != undefined ? (updateVars['familyName'] = this.familyName) : "";
      this.givenName != undefined ? (updateVars['givenName'] = this.givenName) : "";
      this.businessName != undefined ? (updateVars['businessName'] = this.businessName) : "";
      this.phone != undefined ? (updateVars['phone'] = this.phone) : "";
      this.physicalAddress != undefined ? (updateVars['physicalAddress'] = this.physicalAddress) : [];
      this.physicalCity != undefined ? (updateVars['physicalCity'] = this.physicalCity) : "";
      this.physicalState != undefined ? (updateVars['physicalState'] = this.physicalState) : "";
      this.physicalZip != undefined ? (updateVars['physicalZip'] = this.physicalZip) : "";
      this.physicalCountry != undefined ? (updateVars['physicalCountry'] = this.physicalCountry) : "";
      this.billingAddress != undefined ? (updateVars['billingAddress'] = this.billingAddress) : [];
      this.billingCity != undefined ? (updateVars['billingCity'] = this.billingCity) : "";
      this.billingState != undefined ? (updateVars['billingState'] = this.billingState) : "";
      this.billingZip != undefined ? (updateVars['billingZip'] = this.billingZip) : "";
      this.billingCountry != undefined ? (updateVars['billingCountry'] = this.billingCountry) : "";
      this.termsOfService != undefined ? (updateVars['termsOfService'] = this.termsOfService) : "";
      this.receiveInfo != undefined ? (updateVars['receiveInfo'] = this.receiveInfo) : "";
      this.nameTitle != undefined ? (updateVars['nameTitle'] = this.nameTitle) : "";
      this.businessWebSite != undefined ? (updateVars['businessWebSite'] = this.businessWebSite) : "";
      this.businessNotes != undefined ? (updateVars['businessNotes'] = this.businessNotes) : "";
      this.businessTimezone != undefined ? (updateVars['businessTimezone'] = this.businessTimezone) : "";
      this.businessPhoneNumbers != undefined ? (updateVars['businessPhoneNumbers'] = this.businessPhoneNumbers) : [];
      return updateVars;
    }

    loadResults(returnResults){
      this.accountId = returnResults.accountId != undefined ? returnResults.accountId : "";
      this.email = returnResults.email != undefined ? returnResults.email : undefined;
      this.familyName = returnResults.familyName != undefined ? returnResults.familyName : undefined;
      this.givenName = returnResults.givenName != undefined ? returnResults.givenName : undefined;
      this.businessName = returnResults.businessName != undefined ? returnResults.businessName : undefined;

      this.phone = returnResults.phone != undefined ? returnResults.phone : undefined;
      this.physicalAddress = returnResults.physicalAddress != undefined ? returnResults.physicalAddress : [];
      this.physicalCity = returnResults.physicalCity != undefined ? returnResults.physicalCity : undefined;
      this.physicalState = returnResults.physicalState != undefined ? returnResults.physicalState : undefined;
      this.physicalZip = returnResults.physicalZip != undefined ? returnResults.physicalZip : undefined;
      this.physicalCountry = returnResults.physicalCountry != undefined ? returnResults.physicalCountry : undefined;
      this.physicalCountryStateCity = returnResults.physicalCountryStateCity != undefined ? returnResults.physicalCountryStateCity : undefined;
      this.billingAddress = returnResults.billingAddress != undefined ? returnResults.billingAddress : [];
      this.billingCity = returnResults.billingCity != undefined ? returnResults.billingCity : undefined;
      this.billingState = returnResults.billingState != undefined ? returnResults.billingState : undefined;
      this.billingZip = returnResults.billingZip != undefined ? returnResults.billingZip : undefined;
      this.billingCountry = returnResults.billingCountry != undefined ? returnResults.billingCountry : undefined;
      this.termsOfService = returnResults.termsOfService != undefined ? returnResults.termsOfService : undefined;
      this.receiveInfo = returnResults.receiveInfo != undefined ? returnResults.receiveInfo : undefined;
      this.nameTitle = returnResults.nameTitle != undefined ? returnResults.nameTitle : undefined;
      this.businessWebSite = returnResults.businessWebSite != undefined ? returnResults.businessWebSite : undefined;
      this.businessNotes = returnResults.businessNotes != undefined ? returnResults.businessNotes : undefined;
      this.businessTimezone = returnResults.businessTimezone != undefined ? returnResults.businessTimezone : undefined;
      this.version = returnResults.version != undefined ? returnResults.version : 0;

      this.businessPhoneNumbers = returnResults.businessPhoneNumbers != undefined ? returnResults.businessPhoneNumbers : [];
      if(this.businessPhoneNumbers.length == 0 ){
        let phone = {"phone":"","preferred":true,"mobile":false};
        this.businessPhoneNumbers = [];
        this.businessPhoneNumbers.push(phone);
      }

      this.proxyUsers = returnResults.proxyUsers != undefined ? returnResults.proxyUsers : [];
      this.proxyUserIds = [];
      this.modifiedProxyUserIds = [];
      for(let item of this.proxyUsers){
        this.proxyUserIds.push(item['accountId']);
        this.modifiedProxyUserIds.push(item['accountId']);
      }

      this.associatedBusinesses = returnResults.associatedBusinesses != undefined ? returnResults.associatedBusinesses : [];
      this.associatedBusinessIds = [];
      this.modifiedAssociatedBusinessIds = [];
      for(let item of this.associatedBusinesses){
        this.associatedBusinessIds.push(item['accountId']);
        this.modifiedAssociatedBusinessIds.push(item['accountId']);
      }
    }

    getFullName():string {
      var returnValue = "";
      if(this.givenName.length===0 && this.familyName.length===0){
        returnValue = this.email;
      }
      else{
        var separator = (this.givenName.length > 0) ? ' ' : ''
        returnValue =  this.givenName + separator + this.familyName;
      }
      return returnValue;
    }

    getDisplayablePhysicalLocation():string{
      let city = this.physicalCity != undefined ? this.physicalCity + ", " : "";
      let state = this.physicalState != undefined ? this.physicalState + " ": "";
      return city + state;
    }

    initNewBusiness(){
      let phone = {"phone":"","preferred":true,"mobile":false};
      this.businessPhoneNumbers = [];
      this.businessPhoneNumbers.push(phone);
      this.proxyUserIds = [];
      this.modifiedProxyUserIds = [];
      this.associatedBusinessIds = [];
      this.modifiedAssociatedBusinessIds = [];
    }

  async saveProxyUsers(){

    /* Add proxy users that do not exist*/
    for(let item of this.modifiedProxyUserIds){
      if(!this.proxyUserIds.includes(item)){
        await this.addProxyUser(item);
      }
    }

    /* Delete proxy users */
    for(let item of this.proxyUserIds){
      if(!this.modifiedProxyUserIds.includes(item)){
        await this.deleteProxyUser(item,this.accountId);
      }
    }
  }

  async deleteProxyUsers(){
    /* Delete proxy users */
    for(let item of this.proxyUserIds){
        await this.deleteProxyUser(item,this.accountId);
    }
  }

  async deleteBusinessAssociatons(){
    /* Delete business associations */
    for(let item of this.associatedBusinessIds){
        await this.deleteProxyUser(this.accountId,item);
    }
  }

  async addProxyUser(userAccountId:string){
    try{
      const response = (await API.graphql(graphqlOperation(addBusinessUser,{accountId:userAccountId,businessAccountId:this.accountId}))) as {
        data: AddBusinessUserMutation;
      };

      if(response.data == undefined || response.data.addBusinessUser == undefined){
        throw new Error('Error adding proxy user to business. Contact your administrator.');
      }
      return;
    }
    catch(err){
      var errorMsg = err.errors != undefined ? err.errors[0].message : err;
      console.log('error adding proxy user to business',err);
      throw(errorMsg)
    }
  }

  async deleteProxyUser(userAccountId:string,businessAccountId:string){
    // console.log(userAccountId," ",businessAccountId);
    try{
      const response = (await API.graphql(graphqlOperation(deleteBusinessUser,{accountId:userAccountId,businessAccountId:businessAccountId}))) as {
        data: DeleteBusinessUserMutation;
      };

      console.log(response);
      if(response.data == undefined || response.data.deleteBusinessUser == undefined){
        throw new Error('Error deleting proxy user from business. Contact your administrator.');
      }
      return;
    }
    catch(err){
      var errorMsg = err.errors != undefined ? err.errors[0].message : err;
      console.log('error deleting proxy user from business',err);
      throw(errorMsg)
    }
  }

}
